export const customDatePickerStyles = (colors) => {
    var _a, _b, _c, _d;
    return `
  .react-calendar__tile--active {
    background: ${(_a = colors === null || colors === void 0 ? void 0 : colors.selectedBackgroundColor) !== null && _a !== void 0 ? _a : '#EBFF00'}  !important;
    color:  ${(_b = colors === null || colors === void 0 ? void 0 : colors.selectedTextColor) !== null && _b !== void 0 ? _b : '#000000'}  !important;
  }
  .react-calendar__year-view__months{
    .react-calendar__tile--now {
      background: ${(_c = colors === null || colors === void 0 ? void 0 : colors.selectedBackgroundColor) !== null && _c !== void 0 ? _c : '#EBFF00'}  !important;
      color:  ${(_d = colors === null || colors === void 0 ? void 0 : colors.selectedTextColor) !== null && _d !== void 0 ? _d : '#000000'}  !important;
    }
  }
  .react-date-picker__wrapper{
    width: 100%;
    display: none;
  }
  
  .react-calendar {
    border-color: rgb(222, 222, 222);
    border-radius: 10px;
    margin-top: 1rem;
  }
  
  
  .react-calendar__navigation {
    margin-top: 1rem;
    background: rgb(239, 239, 239);
    margin-left: 1rem;
    margin-right: 1rem;
    border-radius: 1.25rem;
    padding-top: 0rem;
    display: flex;
    align-items: center;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    height: auto !important;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  
  .react-calendar__navigation__arrow {
    background: #000000 !important;
    color: #ffffff !important;
    border-radius: 50%;
    min-width: 20px !important;
    width: 20px !important;
    height: 20px !important;
    min-height: 20px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 0.125rem;
  }
  
  .react-calendar__tile--active {
    display: flex;
    justify-content: center;
    align-items: center;
    abbr {
      background: #ffff !important;
      border-radius: 50%;
      height: 1.16rem;
      width: 1.16rem;
      margin-top: 0.35rem;
      padding-top: 0.05rem;
    }
  }
  
  .react-calendar__navigation__arrow:nth-last-child(2), .react-calendar__navigation__arrow:first-child {
    margin-right: 0.25rem !important;
  }
  
  .react-calendar__navigation__label {
    min-height: 24px;
    height: 24px;
    font-size: 1rem;
    font-weight: bold;
  }
  
  @media only screen and (max-width: 992px),
  (min-device-width: 768px) and (max-device-width: 992px) {
    .react-calendar {
      margin: 0.25rem;
      padding: 0.25rem;
    }
    .react-calendar__month-view__weekdays {
      margin: 0.25rem;
    }
    .react-calendar__month-view__days {
      margin: 0.25rem;
      .react-calendar__tile {
        background: rgb(239, 239, 239);
      }
    }
    .react-calendar__month-view__days__day--weekend {
      color: black;
    }
  }
  
  @media only screen and (min-width: 992px) {
    .react-calendar {
      min-width: 25.25rem !important;
    }
    .react-calendar__month-view__days>.react-calendar__tile {
      background: rgb(239, 239, 239);
      margin: 0.5rem;
      max-width: 3rem;
      max-height: 1.5rem;
      padding-top: 0.25rem;
      border-radius: 0.25rem;
    }
    .react-calendar__month-view__days__day--weekend {
      color: black;
    }
  }
  `;
};
//# sourceMappingURL=picker-styles.js.map